import { PP_SUBNAV, type PatientProfileTab } from '@elva/ui';

const TAB_SET = new Set<string>(PP_SUBNAV);

/** URL slug per tab (amendment 30 §2). */
export const TAB_SLUG: Record<PatientProfileTab, string> = {
  Profile: 'profile',
  Communications: 'communications',
  Insurance: 'insurance',
  Forms: 'forms',
  Treatments: 'treatments',
  Invisalign: 'invisalign',
};

const SLUG_TO_TAB: Record<string, PatientProfileTab> = Object.fromEntries(
  Object.entries(TAB_SLUG).map(([tab, slug]) => [slug, tab as PatientProfileTab]),
) as Record<string, PatientProfileTab>;

export function patientProfilePath(
  patientId: string | number,
  tab: PatientProfileTab = 'Profile',
): string {
  return `/patients/${patientId}/${TAB_SLUG[tab]}`;
}

export function parsePatientProfileTab(tabParam: string | undefined): PatientProfileTab | null {
  if (!tabParam) return null;
  if (TAB_SET.has(tabParam)) return tabParam as PatientProfileTab;
  return SLUG_TO_TAB[tabParam.toLowerCase()] ?? null;
}
